/* ════════════════════════════════════════════════════
   DIAMOND SWIMWEAR — CART LOGIC
   assets/diamond-cart.js
   AJAX en vivo con la Cart API de Shopify (/cart/*.js)
   ════════════════════════════════════════════════════ */
(function () {
  'use strict';

  const root = document.querySelector('[data-cart-root]');
  if (!root) return;

  const FREE_SHIP = (window.DS_FREE_SHIP || 75) * 100; // en centavos
  const moneyFormat = window.DS_MONEY_FORMAT || '${{amount}}';

  /* ── Formato de dinero (fallback simple en USD) ── */
  function formatMoney(cents) {
    const value = (cents / 100).toFixed(2);
    return moneyFormat
      .replace('{{amount}}', value)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', value.replace('.', ','));
  }

  /* ── Helpers de red ── */
  async function postJSON(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body),
    });
    return res.json();
  }
  async function getCart() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    return res.json();
  }

  /* ── Actualiza cantidad por key ── */
  async function changeQty(key, quantity) {
    return postJSON('/cart/change.js', { id: key, quantity });
  }

  /* ── Re-render de totales y barra de envío sin recargar ── */
  function refreshSummary(cart) {
    const subtotalEl = root.querySelector('[data-cart-subtotal]');
    const totalEl    = root.querySelector('[data-cart-total]');
    const countEl    = root.querySelector('[data-cart-count]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (totalEl)    totalEl.textContent    = formatMoney(cart.total_price);
    if (countEl)    countEl.textContent    = '(' + cart.item_count + ')';

    // Badge global del header (si existe)
    document.querySelectorAll('[data-cart-count], .cart-badge, #cartBadge').forEach(el => {
      if (el.classList.contains('cart-badge') || el.id === 'cartBadge') {
        el.textContent = cart.item_count;
      }
    });

    // Barra de envío
    const fill = root.querySelector('[data-ship-fill]');
    const text = root.querySelector('[data-ship-text]');
    if (fill) {
      const pct = Math.min(100, (cart.total_price / FREE_SHIP) * 100);
      fill.style.width = pct + '%';
    }
    if (text) {
      const remaining = FREE_SHIP - cart.total_price;
      if (remaining > 0) {
        text.classList.remove('dscart__ship-text--unlocked');
        text.innerHTML = 'Te faltan <strong>' + formatMoney(remaining) +
          '</strong> para <span>envío gratis</span>';
      } else {
        text.classList.add('dscart__ship-text--unlocked');
        text.innerHTML = '✦ ¡Felicidades! Tienes <span>envío gratis</span> ✦';
      }
    }
  }

  /* ── Si el carrito queda vacío, recarga para mostrar el estado vacío ── */
  function maybeReloadIfEmpty(cart) {
    if (cart.item_count === 0) window.location.reload();
  }

  /* ── Delegación de eventos ── */
  root.addEventListener('click', async (e) => {
    const itemEl = e.target.closest('[data-cart-item]');

    /* + / − cantidad */
    const plus  = e.target.closest('[data-qty-plus]');
    const minus = e.target.closest('[data-qty-minus]');
    if ((plus || minus) && itemEl) {
      const input = itemEl.querySelector('[data-qty-input]');
      let qty = parseInt(input.value, 10) || 0;
      qty = plus ? qty + 1 : Math.max(0, qty - 1);
      input.value = qty;
      await applyQty(itemEl, qty);
      return;
    }

    /* Eliminar */
    const remove = e.target.closest('[data-remove]');
    if (remove && itemEl) {
      itemEl.classList.add('is-removing');
      const key = itemEl.dataset.key;
      const cart = await changeQty(key, 0);
      itemEl.remove();
      refreshSummary(cart);
      maybeReloadIfEmpty(cart);
      return;
    }
  });

  /* ── Cambio manual del input ── */
  root.addEventListener('change', async (e) => {
    const input = e.target.closest('[data-qty-input]');
    if (!input) return;
    const itemEl = e.target.closest('[data-cart-item]');
    let qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    input.value = qty;
    await applyQty(itemEl, qty);
  });

  async function applyQty(itemEl, qty) {
    const key = itemEl.dataset.key;
    itemEl.style.opacity = '.5';
    const cart = await changeQty(key, qty);
    itemEl.style.opacity = '';
    if (qty === 0) {
      itemEl.remove();
      maybeReloadIfEmpty(cart);
    } else {
      // actualiza el precio de línea del item
      const lineItem = cart.items.find(i => i.key === key);
      if (lineItem) {
        const priceEl = itemEl.querySelector('.dscart-item__price');
        if (priceEl) {
          if (lineItem.original_line_price !== lineItem.final_line_price) {
            priceEl.innerHTML = '<span class="dscart-item__price-sale">' +
              formatMoney(lineItem.final_line_price) + '</span> <s>' +
              formatMoney(lineItem.original_line_price) + '</s>';
          } else {
            priceEl.textContent = formatMoney(lineItem.final_line_price);
          }
        }
      }
    }
    refreshSummary(cart);
  }

  /* ── Guarda la nota del pedido al escribir (debounced) ── */
  const noteInput = root.querySelector('.dscart__note-input');
  if (noteInput) {
    let t;
    noteInput.addEventListener('input', () => {
      clearTimeout(t);
      t = setTimeout(() => {
        postJSON('/cart/update.js', { note: noteInput.value });
      }, 600);
    });
  }
})();
